import { render, staticRenderFns } from "./List-Orders.vue?vue&type=template&id=1f316278&scoped=true"
import script from "./List-Orders.vue?vue&type=script&lang=js"
export * from "./List-Orders.vue?vue&type=script&lang=js"
import style0 from "./List-Orders.vue?vue&type=style&index=0&id=1f316278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f316278",
  null
  
)

export default component.exports